const React = require('react');

const Content = require('../common/Content.jsx');
const Meta = require('../common/Meta.jsx');
const Token = require('../utility/Token.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region DATE

function InvoiceDate(props) {
    const data = props.data || {};
    return <Content.LabelValue {...props} formatValue={false} value={data.Date} />;
}
const TypeConfigInvoiceDate = {
    panel: {
        block: function (label) {
            let labelValue = 'Invoice Date: ';
            if (label && label.value) {
                labelValue = label.value;
            }
            return {
                label: 'Block Configuration',
                options: [
                    Content.TypeConfig.labelValue.options.displayType({ value: 'inline' }),
                    { display: 'Label Properties', id: 'labelProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({}, { value: labelValue }, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Value Properties', id: 'valueProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.value({}, {}, {})
                ]
            }
        },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

// #endregion DATE

// #region NUMBER

function InvoiceNumber(props) {
    const data = props.data || {};
    let description;
    if (data.Status == 2) {
        let style;
        if (props.config && props.config.Config && props.config.Config.Block) {
            const blockProps = props.config.Config.Block;
            if (blockProps.styleDescription == undefined) {
                // Legacy
                blockProps.fontSizeDescription = blockProps.fontSizeLabel;
                blockProps.fontWeightDescription = blockProps.fontWeightLabel;
                blockProps.lineHeightDescription = blockProps.lineHeightLabel;
                blockProps.styleDescription = blockProps.styleLabel;
                blockProps.paddingLeftDescription = blockProps.paddingLeftLabel;
                if (blockProps.columnSpacing) {
                    blockProps.paddingRightDescription = blockProps.columnSpacing;
                } else {
                    blockProps.paddingRightDescription = blockProps.paddingRightLabel;
                }
                blockProps.textAlignDescription = blockProps.textAlignLabel;
            }
            style = Utilities.Config.getStyle(data, blockProps, 'Description', { whiteSpace: 'pre-wrap' });

            if (blockProps.displayType == 'inline' && !Utilities.isNullOrWhitespace(blockProps.marginRightDescription)) {
                style.marginRight = blockProps.marginRightDescription;
            } else {
                style.marginRight = undefined
            }
        }
        description = <span style={style}>On Approval </span>;
    }
    return <Content.LabelValue {...props} description={description} formatValue={false} value={data.Number} />;
}
const TypeConfigInvoiceNumber = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    Content.TypeConfig.labelValue.options.displayType({ value: 'inline' }),
                    { display: 'Invoice Status Properties', id: 'descriptionProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({ name: 'Description' }, undefined, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Label Properties', id: 'labelProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({}, { value: 'Invoice #' }, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Value Properties', id: 'valueProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.value({}, {})
                ]
            };
        },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

// #endregion NUMBER

// #region NUMBER V2

function _NumberV2(props) {
    const data = props.data || {};
    const hasValue = !Utilities.isNullOrWhitespace(data.Number);
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />
}
const NumberV2 = Content.withLabelTokenParsing(_NumberV2, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Invoice.Number:
            if (!Utilities.isNullOrWhitespace(data.Number)) {
                replaceString = Token.getReplacementString(data.Number, options);
            }
            break;
        case Token.Invoice.Status:
            switch (data.Status) {
                case 1:
                    if (options && options.open == 'true') {
                        replaceString = Token.getReplacementString('Open', options);
                    }
                    break;
                case 2:
                    if (options && options.approval == 'true') {
                        replaceString = Token.getReplacementString('On Approval', options);
                    }
                    break;
                case 3:
                    if (options && options.closed == 'true') {
                        replaceString = Token.getReplacementString('Closed', options);
                    }
                    break;
                case 4:
                    if (options && options.declined == 'true') {
                        replaceString = Token.getReplacementString('Declined', options);
                    }
                    break;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensNumber = () => {
    const invoiceStatusToken = Token.getWrappedTokenConfig('Invoice Status', Token.Invoice.Status);
    invoiceStatusToken.options.push(
        { defaultValue: 'false', label: 'Open', name: 'open', type: 'toggle-small' },
        { defaultValue: 'true', label: 'On Approval', name: 'approval', type: 'toggle-small' },
        { defaultValue: 'false', label: 'Closed', name: 'closed', type: 'toggle-small' },
        { defaultValue: 'false', label: 'Declined', name: 'declined', type: 'toggle-small' }
    );
    return [
        Token.getWrappedTokenConfig('Invoice Number', Token.Invoice.Number),
        invoiceStatusToken
    ]
};
const TypeConfigNumberV2 = {
    panel: {
        block: () => Content.TypeConfig.labelValue.panelV2.block('3'),
        description: () => Content.TypeConfig.labelValue.panelV2.description(Utilities.wrapTextForEditor({ text: `{${Token.Invoice.Status}("before":"","after":"","open":"false","approval":"true","closed":"false","declined":"false")}`, token: Token.Invoice.Status })),
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: 'Invoice #' })),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: () => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Invoice.Number}("before":"","after":"")}`, token: Token.Invoice.Number }))
    }
};

// #endregion NUMBER V2

// #region STAFF

function Staff(props) {
    const data = props.data || {};
    const hasStaff = !Utilities.isNullOrWhitespace(data.StaffName);
    if (!props.builder) {
        if (!hasStaff) {
            return null;
        }
        const config = props.config || {};
        if (!props.forceVisibility && !Utilities.Config.getVisibility(config, 'Staff')) {
            return null;
        }
    }
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasStaff} value={data.StaffName} />;
}
const TypeConfigStaff = {
    panel: {
        block: function (label) {
            let labelValue = 'Staff: ';
            if (label && label.value) {
                labelValue = label.value;
            }
            return {
                label: 'Block Configuration',
                options: [
                    Content.TypeConfig.labelValue.options.displayType({ value: 'inline' }),
                    { display: 'Label Properties', id: 'labelProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({}, { value: labelValue }, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Value Properties', id: 'valueProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.value({}, {}, {})
                ]
            };
        },
        
        style: Content.TypeConfig.labelValue.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Staff',
                        name: 'Staff',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

// #endregion STAFF

// #region TAX

function TaxLine(props) {
    const data = props.data || {};
    let gst = false;
    if (data.Inventory) {
        for (let i = 0; i < data.Inventory.length; i++) {
            if (data.Inventory[i].Tax == 1) {
                gst = true;
                break;
            }
        }
    }
    if (!props.builder && !gst) {
        return null;
    }

    let displayText;
    if (gst) {
        const config = props.config || {};
        let blockProps = {};
        if (config.Config && config.Config.Block) {
            blockProps = config.Config.Block;
        }
        displayText = blockProps.displayText;
    }
    return <Content.Value {...props} styleName="Value" value={displayText} />;
}
const TypeConfigTaxLine = {
    panel: {
        block: function () { return Content.TypeConfig.value.panel.blockWithLabel({ name: 'displayText', value: 'Tax Invoice' }, { name: 'Value' }); },
        style: Content.TypeConfig.value.panel.style
    }
};

// #endregion TAX

// #region TAX V2

function TaxLineV2(props) {
    const data = props.data || {};
    let gst = false;
    if (data.Inventory) {
        for (let i = 0; i < data.Inventory.length; i++) {
            if (data.Inventory[i].Tax == 1) {
                gst = true;
                break;
            }
        }
    }
    if (!props.builder && !gst) {
        return null;
    }
    let design;
    if (gst && props.config && props.config.config && props.config.config.Block) {
        design = props.config.config.Block.design;
    }
    return <Content.Value {...props} value={design} />
}
const TypeConfigTaxLineV2 = {
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Display Text',
                        fullWidth: true,
                        group,
                        name: 'design',
                        type: 'rich-text-collateral',
                        value: Utilities.wrapTextForEditor({ text: 'Tax Invoice' })
                    }
                ]
            };
        },
        style: () => Content.TypeConfig.value.panel.styleV2('style')
    }
};

// #endregion TAX V2

module.exports = {
    InvoiceDate: {
        Component: InvoiceDate,
        TypeConfig: TypeConfigInvoiceDate
    },
    InvoiceNumber: {
        Component: InvoiceNumber,
        TypeConfig: TypeConfigInvoiceNumber
    },
    Staff: {
        Component: Staff,
        TypeConfig: TypeConfigStaff
    },
    TaxLine: {
        Component: TaxLine,
        TypeConfig: TypeConfigTaxLine
    },

    V2: {
        ...Meta,
        Number: {
            Component: NumberV2,
            Tokens: TokensNumber,
            TypeConfig: TypeConfigNumberV2
        },
        TaxLine: {
            Component: TaxLineV2,
            TypeConfig: TypeConfigTaxLineV2
        }
    }
};